import axios from 'axios';

export const getUserIPAddress = async () => {
  const { data } = await axios.get('https://api.ipify.org/?format=json');
  return data?.ip || 'Unknown IP';
};
